// extracted by mini-css-extract-plugin
module.exports = {"sueffa":"sueffa","slick-slide":"slick-slide","slick-arrow":"slick-arrow","a5newwo":"a5newwo"};